// src/pages/ThankYou.jsx
import React from "react";
import { Link } from "react-router-dom";
import "../style/ThankYou.css";

const ThankYou = () => {
  return (
    <div className="thank-you__container">
      <div className="thank-you__message-box">
        <h1 className="thank-you__title">Thank You!</h1>
        <p className="thank-you__text">
          Your AI Mock Test has been submitted successfully.
          <br />
          We appreciate your time and effort.
        </p>
        <Link className="thank-you__back-home-btn" to="/">
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default ThankYou;
